import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { nsSharedStyles } from '../ns-styles/index.js';

export interface TestCredential {
  label: string;
  value: string;
  digits?: boolean;
}

@customElement('ns-test-credentials')
export class NSTestCredentials extends LitElement {
  @property({ attribute: false })
  rows: TestCredential[] = [];

  static styles = [
    nsSharedStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
      }

      .row {
        display: flex;
        align-items: center;
        margin-bottom: var(--ns-test-credentials-gap, var(--wa-space-2xs));
      }

      .label {
        margin-right: var(--wa-space-2xs);
      }

      .value {
        padding: var(--wa-space-2xs) var(--wa-space-xs);
        border-radius: var(--wa-border-radius-l);
        background: var(--ns-theme-grey-dark);
        color: var(--ns-theme-white);
        font-size: var(--wa-font-size-xs);
      }

      .value.fill {
        flex: 1;
      }

      .digits {
        display: contents;
      }

      .digits .value:not(:last-child) {
        margin-right: var(--wa-space-2xs);
      }

      .digits .value {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
      }
    `,
  ];

  render() {
    return html`
      <slot></slot>
      ${this.rows.map(
        (row) => html`
          <div class="row">
            <div class="label">${row.label}:</div>
            ${row.digits
              ? html`
                  <div class="digits">
                    ${[...row.value].map(
                      (digit) => html`
                        <div class="value">${digit}</div>
                      `,
                    )}
                  </div>
                `
              : html`
                  <div class="value fill">${row.value}</div>
                `}
          </div>
        `,
      )}
    `;
  }
}
